import React from "react";
import { AHIcon, AHText, Box } from "arkh";
import { DateTime } from "luxon";

export function WidgetTeamScheduleTimeRangeIndicator({
  fmt,
  startAt,
  deadlineAt,
}: {
  fmt: string;
  startAt: string;
  deadlineAt: string | null | undefined;
}) {
  return (
    <Box
      style={{ flexDirection: "row", alignItems: "center" }}
      spaceBottom="xsmall"
    >
      <AHText type="info-small" color="text-secondary">
        {capFirstLetter(DateTime.fromISO(startAt).toFormat(fmt).toString())}
      </AHText>
      {deadlineAt ? (
        <AHIcon
          type="arrow-right"
          color="text-secondary"
          spaceHorizontal="xsmall"
          size="detail"
        />
      ) : null}
      {deadlineAt ? (
        <AHText type="info-small" color="text-secondary">
          {capFirstLetter(
            DateTime.fromISO(deadlineAt).toFormat(fmt).toString()
          )}
        </AHText>
      ) : null}
    </Box>
  );
}

function capFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
